import { render, staticRenderFns } from "./OrganizationsPage.vue?vue&type=template&id=53e419a8&scoped=true&"
import script from "./OrganizationsPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e419a8",
  null
  
)

export default component.exports